import { Reveal } from "./Reveal";
import { useLang } from "@/lib/i18n";

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative border-t border-white/10 bg-[#0B0C10] py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal className="mb-16 md:mb-24 max-w-3xl">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-[#0057B7]">
            {t.man_label}
          </span>
          <h2 className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight">
            {t.man_heading}
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {t.man_chapters.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.12}
              className="bg-[#0B0C10] p-8 md:p-10 group hover:bg-[#101119] transition-colors duration-500"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="flex items-baseline gap-4">
                <span className={`font-heading text-5xl md:text-6xl font-semibold transition-colors duration-500 group-hover:text-[#D4AF37] ${
                  i === 0 ? "text-[#E11B22]" : i === 1 ? "text-zinc-400" : "text-[#0057B7]"
                }`}>
                  {c.n}
                </span>
                <span className="h-px flex-1 bg-white/10" />
              </div>
              <h3 className="mt-6 font-heading text-xl md:text-2xl font-medium text-white">{c.title}</h3>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-zinc-300">
                {c.body}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
